import { z } from 'zod';
// --- Usuario ---
export const TIPOS_PERSONA_USUARIO = ['INSTRUCTOR', 'PROMOTOR'];
const ActorRefSchema = z.object({
    id: z.string().uuid(),
    nombre: z.string(),
    email: z.string(),
});
export const UsuarioAdminSchema = z.object({
    id: z.string().uuid(),
    email: z.string(),
    nombre: z.string(),
    apellido: z.string(),
    emailVerificado: z.boolean().optional(),
    ultimoLogin: z.string().nullable().optional(),
    activo: z.boolean(),
    personaTipo: z.enum(TIPOS_PERSONA_USUARIO).nullable().optional(),
    personaId: z.string().uuid().nullable().optional(),
    personaNombre: z.string().nullable().optional(),
    grupos: z.array(z.object({ id: z.string().uuid(), nombre: z.string() })),
    creadoEn: z.string().optional(),
    creadoPor: ActorRefSchema.nullable().optional(),
    actualizadoEn: z.string().optional(),
    actualizadoPor: ActorRefSchema.nullable().optional(),
});
export const PaginacionSchema = z.object({
    total: z.number(),
    pagina: z.number(),
    porPagina: z.number(),
    totalPaginas: z.number(),
});
export const UsuariosPaginadosSchema = z.object({
    items: z.array(UsuarioAdminSchema),
    paginacion: PaginacionSchema,
});
export const UsuarioFormSchema = z
    .object({
    email: z.string().trim().email('Email inválido').max(150),
    nombre: z.string().trim().min(1, 'Requerido').max(100),
    apellido: z.string().trim().min(1, 'Requerido').max(100),
    password: z.string().optional().or(z.literal('')),
    grupoIds: z.array(z.string().uuid()),
    personaTipo: z.enum(TIPOS_PERSONA_USUARIO).or(z.literal('')).optional(),
    personaId: z.string().uuid().or(z.literal('')).optional(),
})
    .refine((v) => {
    const tipo = v.personaTipo;
    const id = v.personaId;
    if (tipo && tipo !== '' && (!id || id === ''))
        return false;
    return true;
}, { path: ['personaId'], message: 'Elegí la persona a vincular.' });
// --- Grupo ---
export const GrupoAdminSchema = z.object({
    id: z.string().uuid(),
    nombre: z.string(),
    descripcion: z.string().nullable().optional(),
    visibilidadGlobal: z.boolean(),
    sistema: z.boolean(),
    activo: z.boolean(),
    creadoEn: z.string().optional(),
    creadoPor: ActorRefSchema.nullable().optional(),
    actualizadoEn: z.string().optional(),
    actualizadoPor: ActorRefSchema.nullable().optional(),
    permisos: z.array(z.object({
        id: z.number(),
        clave: z.string(),
        modulo: z.string().nullable().optional(),
    })),
});
export const GruposListSchema = z.object({
    items: z.array(GrupoAdminSchema),
});
export const GrupoFormSchema = z.object({
    nombre: z.string().trim().min(1, 'Requerido').max(100),
    descripcion: z.string().max(2000).optional().or(z.literal('')),
    visibilidadGlobal: z.boolean().default(false),
    permisoIds: z.array(z.number()),
});
// --- Permisos ---
export const PermisoSchema = z.object({
    id: z.number(),
    clave: z.string(),
    descripcion: z.string().nullable().optional(),
    modulo: z.string().nullable().optional(),
});
export const PermisosListSchema = z.object({
    items: z.array(PermisoSchema),
});
